/* Somnila v10 / v11 : carrousels [data-s10-rail] (flèches, barre, points de pagination [data-s10-dots]) et onglets [data-s10-tabs].
   Aucune dépendance, ES2019, sans erreur si la page ne contient aucun de ces éléments.
   Réinitialisé à chaque rechargement de section dans l'éditeur de thème. */
(function () {
  'use strict';

  var motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var DOT_LABEL = 'Aller à l’élément {n}';

  function scrollMode() {
    return motion && motion.matches ? 'auto' : 'smooth';
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function within(scope, selector) {
    if (!scope || !scope.querySelectorAll) return [];
    var found = toArray(scope.querySelectorAll(selector));
    if (scope.matches && scope.matches(selector)) found.unshift(scope);
    return found;
  }

  /* ---------- Carrousel ---------- */

  function initRail(root) {
    if (root.__s10Rail) return;
    var track = root.querySelector('[data-s10-track]');
    if (!track) return;

    var prev = root.querySelector('[data-s10-prev]');
    var next = root.querySelector('[data-s10-next]');
    var bar = root.querySelector('.s10-rail-bar');
    var thumb = bar ? bar.querySelector('span') : null;
    var dotsBox = root.querySelector('[data-s10-dots]');
    var dots = [];
    var stops = [0];
    var dirty = true;
    var current = -1;
    var target = -1;
    var lock = 0;
    var frame = 0;
    var observer = null;

    function isRtl() {
      return window.getComputedStyle(track).direction === 'rtl';
    }

    function items() {
      return toArray(track.children).filter(function (item) {
        return item.offsetWidth > 0;
      });
    }

    function stepSize() {
      var item = items()[0];
      if (!item) return track.clientWidth;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    /* Positions de défilement où un élément commence (une par point), sans doublon après la butée de fin. */
    function measure() {
      dirty = false;
      var list = items();
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      var found = [];
      if (list.length && max > 1) {
        var origin = list[0].offsetLeft;
        list.forEach(function (item) {
          var stop = Math.min(max, Math.round(Math.abs(item.offsetLeft - origin)));
          if (!found.length || stop - found[found.length - 1] > 1) found.push(stop);
        });
      }
      stops = found.length ? found : [0];
      if (dotsBox) buildDots();
    }

    function buildDots() {
      var count = stops.length > 1 ? stops.length : 0;
      dotsBox.hidden = count === 0;
      if (dots.length === count) return;
      var label = dotsBox.getAttribute('data-s10-dots-label') || DOT_LABEL;
      while (dotsBox.firstChild) dotsBox.removeChild(dotsBox.firstChild);
      dots = [];
      current = -1;
      for (var i = 0; i < count; i += 1) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('data-s10-dot', String(i));
        dot.setAttribute('aria-label', label.replace('{n}', String(i + 1)));
        if (track.id) dot.setAttribute('aria-controls', track.id);
        dotsBox.appendChild(dot);
        dots.push(dot);
      }
    }

    function nearest(pos) {
      var index = 0;
      var best = Infinity;
      for (var i = 0; i < stops.length; i += 1) {
        var distance = Math.abs(stops[i] - pos);
        if (distance < best) {
          best = distance;
          index = i;
        }
      }
      return index;
    }

    function markDot(index) {
      if (index === current) return;
      current = index;
      dots.forEach(function (dot, i) {
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
          dot.classList.add('is-active');
        } else {
          dot.removeAttribute('aria-current');
          dot.classList.remove('is-active');
        }
      });
    }

    function update() {
      frame = 0;
      if (dirty) measure();
      var max = track.scrollWidth - track.clientWidth;
      var pos = Math.abs(track.scrollLeft);
      if (pos > max) pos = max;
      var fixed = max <= 1;

      if (fixed) {
        root.setAttribute('data-s10-static', '');
      } else {
        root.removeAttribute('data-s10-static');
      }

      if (thumb) {
        var ratio = track.scrollWidth > 0 ? Math.min(1, track.clientWidth / track.scrollWidth) : 1;
        var progress = fixed ? 0 : pos / max;
        var shift = ratio > 0 ? progress * (1 / ratio - 1) * 100 : 0;
        thumb.style.setProperty('--s10-rail-w', (ratio * 100).toFixed(3) + '%');
        thumb.style.setProperty('--s10-rail-x', (isRtl() ? -shift : shift).toFixed(3) + '%');
      }

      if (dots.length) {
        /* Après un clic sur un point, il reste actif pendant le défilement doux au lieu de passer par les points intermédiaires. */
        var at = nearest(pos);
        if (target > -1 && target < dots.length) {
          if (at === target) release();
          else at = target;
        }
        markDot(at);
      }

      var atStart = fixed || pos <= 1;
      var atEnd = fixed || pos >= max - 1;
      var active = document.activeElement;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      if (active === prev && atStart && next && !atEnd) next.focus();
      if (active === next && atEnd && prev && !atStart) prev.focus();
    }

    function schedule(event) {
      if (!event || event.type !== 'scroll') dirty = true;
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    function release() {
      target = -1;
      if (lock) window.clearTimeout(lock);
      lock = 0;
    }

    /* Défilement doux, avec un repli : certains navigateurs n'animent pas le défilement doux
       (onglet en arrière-plan, économie d'énergie) et laissent le carrousel immobile. */
    function scrollToLeft(left) {
      var from = track.scrollLeft;
      if (Math.abs(left - from) < 1) return;
      track.scrollTo({ left: left, behavior: scrollMode() });
      window.setTimeout(function () {
        if (Math.abs(track.scrollLeft - from) < 1) track.scrollLeft = left;
      }, 450);
    }

    function go(direction) {
      var sign = isRtl() ? -1 : 1;
      var from = track.scrollLeft;
      var delta = direction * sign * stepSize();
      track.scrollBy({ left: delta, behavior: scrollMode() });
      /* Repli : certains navigateurs n'animent pas le défilement doux (onglet en arrière-plan, économie d'énergie). */
      window.setTimeout(function () {
        if (Math.abs(track.scrollLeft - from) < 1) track.scrollLeft = from + delta;
      }, 450);
    }

    function goTo(index) {
      if (dirty) measure();
      var stop = stops[Math.max(0, Math.min(stops.length - 1, index))];
      scrollToLeft((isRtl() ? -1 : 1) * stop);
    }

    function onPrev() {
      go(-1);
    }

    function onNext() {
      go(1);
    }

    function onDot(event) {
      var dot = event.target.closest ? event.target.closest('[data-s10-dot]') : null;
      if (!dot || dots.indexOf(dot) < 0) return;
      var index = dots.indexOf(dot);
      release();
      target = index;
      /* Si le défilement est interrompu (doigt, molette), le point suit de nouveau la position réelle. */
      lock = window.setTimeout(function () {
        lock = 0;
        target = -1;
        if (!frame) frame = window.requestAnimationFrame(update);
      }, 900);
      markDot(index);
      goTo(index);
    }

    track.addEventListener('scroll', schedule, { passive: true });
    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    if (dotsBox) dotsBox.addEventListener('click', onDot);
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(function () {
        schedule();
      });
      observer.observe(track);
      items().forEach(function (item) {
        observer.observe(item);
      });
    }

    root.__s10Rail = {
      update: function () {
        dirty = true;
        update();
      },
      goTo: goTo,
      reveal: function (item) {
        var first = items()[0];
        if (!item || !first) return;
        track.scrollTo({ left: (isRtl() ? -1 : 1) * Math.abs(item.offsetLeft - first.offsetLeft), behavior: scrollMode() });
      },
      destroy: function () {
        track.removeEventListener('scroll', schedule);
        if (prev) prev.removeEventListener('click', onPrev);
        if (next) next.removeEventListener('click', onNext);
        if (dotsBox) dotsBox.removeEventListener('click', onDot);
        window.removeEventListener('resize', schedule);
        window.removeEventListener('load', schedule);
        if (observer) observer.disconnect();
        if (frame) window.cancelAnimationFrame(frame);
        release();
        root.__s10Rail = null;
      }
    };

    update();
  }

  /* ---------- Onglets ---------- */

  function initTabs(root) {
    if (root.__s10Tabs) return;
    var list = root.querySelector('[role="tablist"]');
    if (!list) return;
    var tabs = toArray(list.querySelectorAll('[role="tab"]')).filter(function (tab) {
      return tab.closest('[data-s10-tabs]') === root;
    });
    if (!tabs.length) return;

    function panelOf(tab) {
      var id = tab.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }

    function select(tab, moveFocus, silent) {
      tabs.forEach(function (item) {
        var on = item === tab;
        item.setAttribute('aria-selected', on ? 'true' : 'false');
        item.setAttribute('tabindex', on ? '0' : '-1');
        var panel = panelOf(item);
        if (panel) {
          panel.hidden = !on;
          if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '0');
        }
      });
      if (moveFocus) tab.focus();
      if (!silent) {
        root.dispatchEvent(new CustomEvent('s10:tabchange', {
          bubbles: true,
          detail: { tab: tab, index: tabs.indexOf(tab) }
        }));
      }
    }

    function onClick(event) {
      var tab = event.target.closest ? event.target.closest('[role="tab"]') : null;
      if (tab && tabs.indexOf(tab) > -1) select(tab, false, false);
    }

    function onKey(event) {
      var index = tabs.indexOf(document.activeElement);
      if (index < 0) return;
      var last = tabs.length - 1;
      var rtl = window.getComputedStyle(list).direction === 'rtl';
      var target = null;
      switch (event.key) {
        case 'ArrowRight':
          target = rtl ? index - 1 : index + 1;
          break;
        case 'ArrowLeft':
          target = rtl ? index + 1 : index - 1;
          break;
        case 'Home':
          target = 0;
          break;
        case 'End':
          target = last;
          break;
        default:
          return;
      }
      if (target < 0) target = last;
      if (target > last) target = 0;
      event.preventDefault();
      select(tabs[target], true, false);
    }

    list.addEventListener('click', onClick);
    list.addEventListener('keydown', onKey);

    var current = tabs.filter(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    })[0] || tabs[0];
    select(current, false, true);

    root.__s10Tabs = {
      select: function (tab) {
        if (tabs.indexOf(tab) > -1) select(tab, false, false);
      },
      tabFor: function (el) {
        var tab = el.closest('[role="tab"]');
        if (tab && tabs.indexOf(tab) > -1) return tab;
        var panel = el.closest('[role="tabpanel"]');
        if (!panel && el.querySelector) panel = el.querySelector('[role="tabpanel"]');
        if (panel && panel.id) {
          for (var i = 0; i < tabs.length; i += 1) {
            if (tabs[i].getAttribute('aria-controls') === panel.id) return tabs[i];
          }
        }
        var inner = el.querySelector ? el.querySelector('[role="tab"]') : null;
        return inner && tabs.indexOf(inner) > -1 ? inner : null;
      },
      destroy: function () {
        list.removeEventListener('click', onClick);
        list.removeEventListener('keydown', onKey);
        root.__s10Tabs = null;
      }
    };
  }

  /* ---------- Cycle de vie ---------- */

  function init(scope) {
    within(scope, '[data-s10-rail]').forEach(initRail);
    within(scope, '[data-s10-tabs]').forEach(initTabs);
  }

  function teardown(scope) {
    within(scope, '[data-s10-rail]').forEach(function (root) {
      if (root.__s10Rail) root.__s10Rail.destroy();
    });
    within(scope, '[data-s10-tabs]').forEach(function (root) {
      if (root.__s10Tabs) root.__s10Tabs.destroy();
    });
  }

  function start() {
    init(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    teardown(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var el = event.target;
    if (!el || !el.closest) return;

    var tabsRoot = el.closest('[data-s10-tabs]');
    if (tabsRoot && tabsRoot.__s10Tabs) {
      var tab = tabsRoot.__s10Tabs.tabFor(el);
      if (tab) tabsRoot.__s10Tabs.select(tab);
    }

    var railRoot = el.closest('[data-s10-rail]');
    if (railRoot && railRoot.__s10Rail) {
      var item = el.closest('[data-s10-track] > *');
      if (item) railRoot.__s10Rail.reveal(item);
    }
  });
})();
